import { useState, useCallback } from 'react';

export const useColumnWidths = (storageKey, defaults) => {
  const [widths, setWidths] = useState(() => {
    try {
      const saved = localStorage.getItem(storageKey);
      return saved ? { ...defaults, ...JSON.parse(saved) } : defaults;
    } catch {
      return defaults;
    }
  });

  const setWidth = useCallback((key, width) => {
    setWidths((prev) => {
      const next = { ...prev, [key]: width };
      try {
        localStorage.setItem(storageKey, JSON.stringify(next));
      } catch {
        /* quota exceeded — ignore */
      }
      return next;
    });
  }, [storageKey]);

  return [widths, setWidth];
};